<template>
  <b-nav-item-dropdown
    v-if="authStore.isSignedIn && $can('read', 'rota.rotas')"
    variant="link"
    toggle-class="text-decoration-none"
  >
    <template #button-content>
      <font-awesome-icon fixed-width icon="pencil-alt" />
      Rotas
      <shift-cover-approvals-badge
        v-if="$can('update', 'rota.rotas')"
        class="me-1"
      />
    </template>
    <b-dropdown-item :to="{ name: 'rota/RotaDayView' }">
      <font-awesome-icon fixed-width icon="calendar-day" />
      View rota shifts by day
    </b-dropdown-item>
    <b-dropdown-item :to="{ name: 'rota/RotaList' }">
      <font-awesome-icon fixed-width icon="calendar-alt" />
      All rotas
    </b-dropdown-item>
    <b-dropdown-item :to="{ name: 'rota/RotaShiftCover' }">
      <font-awesome-icon fixed-width icon="people-arrows" />
      Shift Cover
      <shift-cover-approvals-badge class="float-end" />
    </b-dropdown-item>
    <div class="dropdown-divider" />
    <b-dropdown-item
      v-if="authStore.isSignedIn && $can('create', 'rota.rotas')"
      :to="{ name: 'rota/RotaCreate' }"
    >
      <font-awesome-icon fixed-width icon="plus" />
      Add a new rota
    </b-dropdown-item>
    <b-dropdown-item
      v-if="authStore.isSignedIn && $can('update', 'rota.rotas')"
      :to="{ name: 'rota/RotaMasterList' }"
    >
      <font-awesome-icon fixed-width icon="edit" />
      Master Rotas
    </b-dropdown-item>
    <div
      v-if="authStore.isSignedIn && $can('update', 'rota.rota-oncall')"
      class="dropdown-divider"
    />
    <b-dropdown-item
      v-if="authStore.isSignedIn && $can('update', 'rota.rota-oncall')"
      :to="{ name: 'rota/OncallEdit' }"
    >
      <font-awesome-icon fixed-width icon="phone-volume" />
      Staff On-call
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { useAuthStore } from "@switchsystems/coactive-vue-lib";
import ShiftCoverApprovalsBadge from "./rota/shift/ShiftCoverApprovalsBadge.vue";

export default {
  components: {
    ShiftCoverApprovalsBadge,
  },
  setup() {
    const authStore = useAuthStore();

    return {
      authStore,
    };
  },
};
</script>
